export default "__VITE_ASSET__5efc418a__"